import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window back to the top whenever the route changes.
 * Skips when the new URL has a hash (so #anchor scroll still works).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    // Use 'instant' so it doesn't visibly scroll up from the bottom on slow
    // devices. Fallback covers older Safari that lacks ScrollToOptions.behavior.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch (_e) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
